import script from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"

import "./btnAnimation.vue?vue&type=style&index=0&id=01b9e1f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b9e1f6"]])

export default __exports__